export default __webpack_public_path__ + "static/media/main-home-header.e5b78212.jpg";